import { type PageShareLinkAttributes } from './generated/PageShareLinkAttributes';
import moment from 'moment';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface PageShareLink extends PageShareLinkAttributes {}

@model
class PageShareLink extends ApplicationModel {
  // Start auto-generated
  static typename: 'PageShareLink' = 'PageShareLink';
  get typename(): 'PageShareLink' {
    return 'PageShareLink';
  }

  static internalTypename: 'PageShareLink' = 'PageShareLink';
  get internalTypename(): 'PageShareLink' {
    return 'PageShareLink';
  }

  static inputType = 'PageShareLinkAttributes!';

  static filterType = 'PageShareLinkFilters!';
  static filters = { pageId: 'ID!', id: '[ID!]', hasEmail: 'Boolean' };

  static fields = {
    access: attr({ writable: true, readable: true }),
    createdAt: attr({ readable: true }),
    email: attr({ readable: true }),
    emailContent: attr({ readable: true }),
    expiresAt: attr({ readable: true }),
    id: attr({ readable: true }),
    private: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    url: attr({ readable: true }),
    page: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Page',
    }),
  };
  // End auto-generated

  hasPermission(accessEnum) {
    return this.access === accessEnum.value;
  }

  get daysRemaining() {
    return Math.round(moment(this.expiresAt).diff(new Date(), 'day', true));
  }
}

export default PageShareLink;
